import { lazyImport } from '../../../Utils/Loading/loadingHelpers'

export const Switch = lazyImport(() => import(/* webpackChunkName: "mui-forms" */ '@mui/material/Switch'))
